import { render, staticRenderFns } from "./addSalon.vue?vue&type=template&id=0de7f523&scoped=true&"
import script from "./addSalon.vue?vue&type=script&lang=js&"
export * from "./addSalon.vue?vue&type=script&lang=js&"
import style0 from "./addSalon.vue?vue&type=style&index=0&id=0de7f523&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de7f523",
  null
  
)

export default component.exports